// extracted by mini-css-extract-plugin
module.exports = {"captchaContainer":"AliyunCaptcha_captchaContainer___udy3","captchaMountNode":"AliyunCaptcha_captchaMountNode__TQEPS","loading":"AliyunCaptcha_loading__Cq_oq"};